package org.moxultimate.topwithmox.shows.data

import kotlinx.serialization.Serializable

/**
 * ShowsTagResponse
 * API response model for a single tag entry from GET /shows-tag.
 */
@Serializable
data class ShowsTagResponse(
    val id: Long,
    val tag: String? = null,
)
